import React from 'react';
import { AmazonTemplatesTemplate } from 'themes/modules/channel/pages';
import { AmazonTemplatesViewStore } from 'modules/channel/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new AmazonTemplatesViewStore(rootStore, componentProps),
	'amazonTemplatesViewStore'
)
class AmazonTemplates extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <AmazonTemplatesTemplate {...this.props} viewStore={this.props.amazonTemplatesViewStore} />;
	}
}

export default AmazonTemplates;



// WEBPACK FOOTER //
// ./src/modules/channel/pages/AmazonTemplates.jsx